import { render, staticRenderFns } from "./AnswerDetailServiceDetail.vue?vue&type=template&id=1640dee3&scoped=true&"
import script from "./AnswerDetailServiceDetail.vue?vue&type=script&lang=js&"
export * from "./AnswerDetailServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnswerDetailServiceDetail.vue?vue&type=style&index=0&id=1640dee3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1640dee3",
  null
  
)

export default component.exports